// extracted by mini-css-extract-plugin
export var main = "docs-layout--main--5cb12";
export var root = "docs-layout--root--19680";
export var skipToMain = "docs-layout--skip-to-main--174fd";